<template>
	<div>
		<waiting v-if="loaded == false" />
		<AlertSendForm :item="selectedItem" @registItem="registItem" @clearItem="clearItem"> </AlertSendForm>
		<AlertHistoryList v-if="loaded" listIcon="mdi-bell" listTitle="알림 이력" :headers="headers" :items="items"> </AlertHistoryList>
	</div>
</template>

<script>
	import { targetUserTypeCode, sendMethodTypeCode, notificationTypeCode } from '@/js/types'; // 절대 경로 사용

	export default {
		name: 'AlertManager',
		props: {},
		data: () => ({
			headers: [
				{
					text: '보낸 날짜',
					align: 'start',
					sortable: true,
					value: 'sendAt',
				},
				{
					text: '제목',
					align: 'start',
					sortable: true,
					value: 'title',
				},
				{
					text: '메시지',
					align: 'start',
					sortable: true,
					value: 'message',
				},
				// {
				// 	text: '발송 주체',
				// 	align: 'start',
				// 	sortable: true,
				// 	value: 'sendUserTypeName',
				// },
				{
					text: '수신 대상',
					align: 'start',
					sortable: true,
					value: 'targetUserTypeName',
				},
				{
					text: '발송 유형',
					align: 'start',
					sortable: true,
					value: 'sendMethodTypeName',
				},
				// {
				// 	text: '성공 여부',
				// 	align: 'start',
				// 	sortable: true,
				// 	value: 'successYn',
				// },
			],
			selectedItem: {},
			items: [],
			loaded: false,
		}),
		mounted: async function() {
			this.items = await this.$database.loadAlerts();
			this.loaded = true;
			this.clearItem();
		},
		methods: {
			clearItem() {
				this.selectedItem = this.$models.AlertModel.create();
			},
			async registItem(item) {
				const currentTimestamp = this.$database.currentTimestamp();

				item.createAt = currentTimestamp;
				item.sendAt = currentTimestamp;

				const targetUsers = await this.getTargetUsers(item);

				if (item.sendMethodType === sendMethodTypeCode.all.code) {
					// 전체일 경우 푸시, 문자 발송
					await this.sendPush(targetUsers, item.message, item.title); // 푸시 보내기
					await this.sendSms(targetUsers, item.message); // 문자 보내기
				} else if (item.sendMethodType === sendMethodTypeCode.push.code) {
					// 푸시
					await this.sendPush(targetUsers, item.message, item.title); // 푸시 보내기
				} else if (item.sendMethodType === sendMethodTypeCode.sms.code) {
					// 문자
					await this.sendSms(targetUsers, item.message); // 문자 보내기
				}

				await this.$database.addAlert(item);
				this.loaded = false;
				this.items = await this.$database.loadAlerts();
				this.clearItem();
				this.loaded = true;
			},
			async sendSms(targetUsers, message) {
				targetUsers.forEach(user => {
					this.$sms.sendSms({
						number: user.phoneNum,
						message,
					});
				});
			},
			async sendPush(targetUsers, message, title) {
				const nowAt = new Date();
				// nowAt.setMinutes(nowAt.getMinutes() + 10); // 10분 뒤

				const testUid = 'i6Wg5ib73Qc5sIZIE9cqO0omgJP2';
				title = title ?? '진담헤어 알림입니다.';

				targetUsers.forEach(user => {
					const receiverUid = process.env.VUE_APP_SYSTEM_MODE === 'production' ? user.uid : testUid;

					const notification = this.$models.NotificationModel.create();
					notification.message = message;
					notification.sendAt = nowAt;
					notification.receiverUid = receiverUid;
					notification.title = title;
					notification.eventWhenClick = '';

					this.$database.addNotification(notification);

					const notificationCenter = this.$models.NotificationCenterModel.create();
					// notificationCenter.id = '';
					notificationCenter.userName = user.nickname;
					notificationCenter.desingerName = '';
					// notificationCenter.hairTitle = '';
					// notificationCenter.reserveDate = '';
					// notificationCenter.appointmentId = '';
					// notificationCenter.appointmentModel = null;
					notificationCenter.createAt = new Date();
					notificationCenter.notificationCheck = false;
					notificationCenter.notificationType = notificationTypeCode.webNotification.code;
					notificationCenter.notificationTypeName = notificationTypeCode.webNotification.text;
					notificationCenter.receiverUid = receiverUid;
					notificationCenter.title;
					notificationCenter.message = message;
					// notificationCenter.topic = '';
					// notificationCenter.eventWhenClick = '';
					this.$database.addNotificationCenter(receiverUid, notificationCenter);
				});
			},
			async getTargetUsers(item) {
				let targetUsers = [];

				if (item.targetUserType === targetUserTypeCode.all.code) {
					targetUsers = await this.$database.loadPushTargetUsers([
						targetUserTypeCode.customer.relatedUserType.code,
						targetUserTypeCode.designer.relatedUserType.code,
					]);
				} else {
					const tUserType = targetUserTypeCode.getItemByCode(item.targetUserType);
					targetUsers = await this.$database.loadPushTargetUsers(tUserType?.relatedUserType.code);
				}

				return targetUsers;
			},
		},
	};
</script>

<style scoped></style>
